module.exports = __webpack_public_path__ + "static/blog-header-b1f69e1ec9d6240c1e92e652612088b5.svg";